import { InjectionToken } from '@angular/core';
import { NFirebase } from './firebase.interface';

declare module '@df/core/df-core.config' {
    interface IDfConfig {
        firebase: NFirebase.IOptions;
    }
}

export const FIREBASE_OPTIONS = new InjectionToken<NFirebase.IOptions>('FIREBASE_OPTIONS');
